import * as React from 'react';
import { TooltipDesktop, InlineText2 } from '@cian/ui-kit';

import { ReliableLabel } from './ReliableLabel';

import * as styles from './styles.css';

export interface IReliableLabelTooltipProps {
  onOpen(): void;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableLabelTooltip({ onOpen, onClick }: IReliableLabelTooltipProps) {
  return (
    <TooltipDesktop
      title={
        <div className={styles['tooltip']}>
          <InlineText2 color="white_100">Подробнее о надёжности</InlineText2>
        </div>
      }
    >
      <div>
        <ReliableLabel onOpen={onOpen} onClick={onClick} />
      </div>
    </TooltipDesktop>
  );
}
